<template>
  <div class="pageScore u-flex-y u-flex-items-center" @click="closeScore">
    <Nav :rType="2" @routerType="changePage"></Nav>
    <div style="height: 68px"></div>
    <div class="selectbox u-flex u-flex-between">
      <div class="leftCheck u-flex">
        <div class="checkItem " @click="switchItem(1,1)" :class="checkStatus  == 1 && hotstatus?'active_check':''">
          热门
        </div>
        <div class="checkItem " @click="switchItem(1)" :class="checkStatus  == 1 && !hotstatus?'active_check':''">
          即时
        </div>
        <div class="checkItem" @click="switchItem(2)" :class="checkStatus  == 2?'active_check':''">
          赛程
        </div>
        <div class="checkItem" @click="switchItem(3)" :class="checkStatus  == 3?'active_check':''">
          赛果
        </div>
      </div>
      <div class="rightCheck u-flex">
        <div class="checkItem "  v-if="!hotstatus">
          <div class="hoverSelectshow" @click.stop="showSelect">
            赛事 <i class="el-icon-arrow-down"></i>
          </div>
          <div class="showselect" v-if="showScores" @click.stop="">
            <div class="beforeSanjiao">
              <img src="https://oss.ansongqiubo.com/static/scope/tk.png" style="width: 20px;height: 11px;" alt="" srcset="">
            </div>
            <div class="alertselect u-flex-y" >
              <div class="u-flex" v-for="(item,index) in selectAllData" :key='index'>
                <div class="leftname">
                  {{item.identify}}
                </div>
                <div class="itembox">
                  <div class="itembox_check" @click="selectItem(items)" v-for="(items,indexs) in item.filtrateList" :key="indexs">
                    <div class="checkState u-flex">
                      <img v-if="items.check" src="https://oss.ansongqiubo.com/static/scope/check.png" style="margin-right: 4px;width: 15px;height: 15px;" alt="" srcset="">
                      <span style="width: 15px;height: 15px;border: 1px solid #999999;box-sizing: border-box; border-radius: 50%;margin-right: 4px;" v-else></span>
                    </div>
                    <div class="itemNames">
                      {{items.nameCnShort}} [{{items.matchCount}}]
                    </div>
                  </div>
                </div>
              </div>
              <div style="width:100%;display: flex;min-height:64px;justify-content: center;">
                  加载到底了
              </div>
            </div>
            <div class="bottom-footer">
              <div class="numsScope">
                  隐藏了{{sumHiddenScopeIndex}}场比赛
              </div>
              <div class="allSelect" @click="checkAll(1)">
                全选
              </div>
              <div class="allSelect"  @click="checkAll(2)">
                反选
              </div>
              <div class="allSelect" @click="checkAll(3)">
                确认
              </div>
            </div>
          </div>
        </div>

        <div class="hoverSelectshow" @click="changeSpeak" style="display: flex;align-items: center;">
          <img v-if="speakstatus == false" src="https://oss.ansongqiubo.com/static/scope/speak.png" style="width: 20px;height: 20px;" alt="" srcset="">
          <img v-else src="https://oss.ansongqiubo.com/static/scope/close_speak.png" style="width: 20px;height: 20px;" alt="" srcset="">
        </div>
      </div>
    </div>
    <div class="u-flex u-flex-items-center myweekdata"  v-if="checkStatus != 1">
      <div class="weeks" @click="changeweekData(item)" :class="checkData.days == item.dateTime?'activedays':''" v-for="(item,index) in weekList" :key="index">
        <div>{{item.time}}</div>
        <div>{{item.name}}</div>
      </div>
    </div>
    <!-- 悬浮框定位 -->
    <div class="dialog_scope" @mouseleave='leaveScopre' @mouseenter="enterScore(item,$event)" :style="{'left':pageX +'px','top':pageY +'px'}">
      <div class="dialogHeaders u-flex u-flex-between" v-if="currentScoreHover.awayTeam">
         <div>{{currentScoreHover.homeTeam.nameCn}}</div>
         <div>{{currentScoreHover.awayTeam.nameCn}}</div>
      </div>
      <!-- 事件 -->
      <div class="u-flex-y dialog_box">
          <div class="myheight" v-if='eventInner && eventInner.length > 0'>
            <div class="u-flex u-flex-between" v-for="(item,index) in eventInner" :key="index">
              <!-- 主队事件 -->
              <div class="u-flex celData u-flex-center" v-if="item.kind == 1">
                <div class="fristOne" style="text-align: right;">{{item.content}} <img style="width: 16px;height: 16px;" :src="'https://oss.ansongqiubo.com/static/scope/state/'+ item.type +'.png'" alt=""> </div>
                <div class="centerOne">{{item.happenTime}}</div>
                <div class="fristOne"></div>
              </div>
              <!-- 客队事件 -->
              <div class="u-flex celData u-flex-center" v-if="item.kind == 2">
                <div class="fristOne"></div>
                <div class="centerOne">{{item.happenTime}}</div>
                <div class="fristOne" style="text-align: left;"><img style="width:16px;height: 16px;" :src="'https://oss.ansongqiubo.com/static/scope/state/'+ item.type +'.png'" alt="">{{item.content}}</div>
              </div>
              <!-- 中间事件 -->
              <div class="u-flex celData u-flex-center" v-if="item.kind == 0">
                <div>{{item.content}}</div>
              </div>
            </div>
          </div>
          <!-- 技术统计 -->
          <div class="eventSums ">
            <div class="eventhander">
              技术统计
            </div>
            <div class="myheight" v-if='serveInner.length > 0'>
              <div class="u-flex u-flex-between itemEvent" v-if="item" v-for="(item,index) in serveInner" :key="index">
                <div>{{item.homeValue}}</div>
                <div v-if="!isNaN(parseInt(item.homeValue ))"  class="progressData"><el-progress :format='formatProgress' :text-inside='true' :show-text='true' :percentage="item.homeValue>=100?100:item.homeValue" color="#721EDC"></el-progress></div>
                <div>{{item.typeValue}}</div>
                <div  v-if="!isNaN(parseInt(item.awayValue ))" class="progressData"><el-progress :format='formatProgress'  :text-inside='true' :show-text='true'  :percentage="item.awayValue>=100?100:item.awayValue" color="#721EDC"></el-progress></div>
                <div>{{item.awayValue}}</div>
              </div>
            </div>
          </div>
      </div>
    </div>
      <!-- 事件提醒 -->
      <div class='event_dialog' :class="dialogCurrentInfo?'event_dialogHide':'event_dialogShow'">
        <div class="eventHome" v-if="currentdialogInfo.kind ==1">
          <div class="eventstateImg">
            <img style="height: 82px;" src="https://oss.ansongqiubo.com/static/scope/eleft.png" alt="" srcset="">
          </div>
          <div class="pkscoreName">
              <div class="event_time">
                {{currentdialogInfo.happenTime}}
              </div>
              <img class="myStateImg"  v-if="currentdialogInfo.type ==1" style="width: 40px;height: 40px;" src="https://oss.ansongqiubo.com/static/scope/big_qiu.png" alt="">
              <img class="myStateImg"  v-if="currentdialogInfo.type ==2" style="width: 40px;height: 40px;" src="https://oss.ansongqiubo.com/static/scope/big_hongpai.png" alt="">
              <img class="myStateImg"  v-if="currentdialogInfo.type ==3" style="width: 40px;height: 40px;" src="https://oss.ansongqiubo.com/static/scope/big_huangpai.png" alt="">

              <div class="homeName">
                {{currentdialogInfo.relationMatchDataVO.homeNameCn}}
              </div>
              <div class="scopeNums"  v-if="currentdialogInfo.type ==1">
                <span>{{currentdialogInfo.relationMatchDataVO.homeScore}}</span> - <span>{{currentdialogInfo.relationMatchDataVO.awayScore}}</span>
              </div>
              <div class="scopeNums"  v-if="currentdialogInfo.type ==2">
                <span style="margin-right: 30px;">{{currentdialogInfo.relationMatchDataVO.homeRedNum}}</span>  <span>{{currentdialogInfo.relationMatchDataVO.awayRedNum}}</span>
              </div>
              <div class="scopeNums"  v-if="currentdialogInfo.type ==3">
                <span style="margin-right: 30px;">{{currentdialogInfo.relationMatchDataVO.homeYellowNum}}</span>  <span>{{currentdialogInfo.relationMatchDataVO.awayYellowNum}}</span>
              </div>
              <div class="awayName">
                {{currentdialogInfo.relationMatchDataVO.awayNameCn}}
              </div>
          </div>
        </div>

        <div class="eventAway" v-if="currentdialogInfo.kind == 2">
          <div class="eventstateImg">
            <img style="height: 82px;" src="https://oss.ansongqiubo.com/static/scope/eright.png" alt="" srcset="">
          </div>
          <div class="pkscoreName" >
              <div class="awayName">
               {{currentdialogInfo.relationMatchDataVO.homeNameCn}}
              </div>
              <div class="scopeNums"  v-if="currentdialogInfo.type ==1">
                <span style="color:#333333;">{{currentdialogInfo.relationMatchDataVO.homeScore}}</span> - <span>{{currentdialogInfo.relationMatchDataVO.awayScore}}</span>
              </div>
              <div class="scopeNums"  v-if="currentdialogInfo.type ==2">
                <span style="color:#333333;margin-right: 30px;">{{currentdialogInfo.relationMatchDataVO.homeRedNum}}</span>  <span>{{currentdialogInfo.relationMatchDataVO.awayRedNum}}</span>
              </div>
              <div class="scopeNums"  v-if="currentdialogInfo.type ==3">
                <span style="color:#333333;margin-right: 30px;">{{currentdialogInfo.relationMatchDataVO.homeYellowNum}}</span>  <span>{{currentdialogInfo.relationMatchDataVO.awayYellowNum}}</span>
              </div>
              <div  class="homeName" >
                 {{currentdialogInfo.relationMatchDataVO.awayNameCn}}
              </div>
              <img class="myStateImg"  v-if="currentdialogInfo.type ==1" style="width: 40px;height: 40px;" src="https://oss.ansongqiubo.com/static/scope/big_qiu.png" alt="">
              <img class="myStateImg"  v-if="currentdialogInfo.type ==2" style="width: 40px;height: 40px;" src="https://oss.ansongqiubo.com/static/scope/big_hongpai.png" alt="">
              <img class="myStateImg"  v-if="currentdialogInfo.type ==3" style="width: 40px;height: 40px;" src="https://oss.ansongqiubo.com/static/scope/big_huangpai.png" alt="">
              <div class="event_time" style="color: #3C87FE;">
                 {{currentdialogInfo.happenTime}}
              </div>
          </div>
        </div>
      </div>
    <div v-if="checkStatus == 1"  v-loading='scoresList[0] && scoresList[0].length == 0 && scoresList[2] && scoresList[2].length == 0 && scoresList[1] && scoresList[1].length == 0'  :class="scoresList[2] && scoresList[2].length == 0 && scoresList[1] && scoresList[1].length == 0?'firstList':'firstListNo'" >
      <!-- 正在进行比赛的标题 -->
      <div class="headerTitle u-flex" v-if="!hotstatus">
        <div class="checkitem"  style="width: 100px;text-align: left;">
          赛事
        </div>
        <div class="checkitem" style="min-width: 60px;text-align: center;">
          时间
        </div>
        <div class="checkitem" style="min-width: 60px;text-align: center;">
          状态
        </div>
        <div class="checkitem"  style="width: 194px;text-align: right;">
          主场球队
        </div>
        <div class="checkitem" style="width: 74px;text-align: center;">
          比分
        </div>
        <div class="checkitem" style="width: 194px;text-align: left;">
          客场球队
        </div>
        <div class="checkitem" style="text-align: center;width: 74px;">
          半场
        </div>
        <div class="checkitem"  style="text-align: center;width: 74px;">
          角球
        </div>
        <div class="checkitem" style="width: 68px;;text-align: center;">
          直播
        </div>
        <div class="checkitem" style="flex: 0.3;text-align: center;"  v-if="checkStatus == 3">
        </div>
        <div class="checkitem" style="flex: .8;text-align: center;" v-if="checkStatus == 2">

        </div>
        <div class="checkitem"  style="flex: 0.6;text-align: center;" v-if="checkStatus == 3">
          胜负
        </div>
        <div class="checkitem"  style="flex:2.2;text-align: center;" v-if="checkStatus == 1">
          走势
        </div>
        <div class="checkitem"  style="text-align: center;flex: 0.6;" v-if="checkStatus == 3">
          让球
        </div>
        <div class="checkitem" style="flex: 0.8;text-align: center;" v-if="checkStatus == 3">
          进球数
        </div>
        <div class="checkitem" style="text-align:right;flex: 0.75;">
          数据中心
        </div>
      </div>
      <div class="headerTitle u-flex  u-flex-between" v-if="hotstatus">
        <div class="checkitem" style="width: 100px;text-align:left">
          赛事
        </div>
        <div class="checkitem" style="min-width: 60px;;text-align: center;">
          时间
        </div>
        <div class="checkitem" style="text-align: center;width: 60px;;">
          状态
        </div>
        <div class="checkitem"  style="width: 194px;;text-align: right;">
          主场球队
        </div>
        <div class="checkitem" style="width: 74px;;text-align: center;">
          比分
        </div>
        <div class="checkitem"  style="width: 194px;;text-align: left;">
          客场球队
        </div>
        <div class="checkitem" style="text-align: center;width: 74px;">
          半场
        </div>
        <div class="checkitem" style="text-align: center;width: 74px;">
          角球
        </div>
        <div class="checkitem" style="min-width:64px;text-align: center;">
          直播
        </div>
        <div class="checkitem" style="text-align:right;width: 80px;">
          数据中心
        </div>
      </div>





      <!-- 正在进行的比赛 -->
      <div class="sectionBox u-flex-y u-flex-center" >
        <div class="u-flex u-flex-items-center" style="margin: 24px; 0"  v-if='scoresList[0].length > 0'>
          <img style="width: 20px;height: 20px;margin-right:6px" src="https://oss.ansongqiubo.com/static/scope/time.png" alt="" srcset="">
          <div class="bisaiCurrent">
            正在进行的比赛
          </div>
        </div>
        <div class="score_game" >
          <div  class="gameBox" v-for="(item,index) in scoresList[0]" :key="index">
            <!-- 加时赛数据 -->
            <div class="addTimeData" v-if="item.matchExtra.normalTime > 0 && item.matchExtra.normalScore !=''">
                {{addTimefif(item.matchExtra,item)}}
            </div>
            <!-- 基础数据 -->
            <div class="game_item"  @click="navChange(item)" >
              <div class="geme_title">
                  <div :style="{'width': '6px','margin-right':'6px','height': '40px','background':item.league.color?item.league.color:'#fff'}"></div>
                  {{item.league.nameCnShort}}
              </div>
              <div class="geme_time" v-if="item.matchInfo">
                <span>
                  {{ffTime(item.matchInfo.matchStartTime)}}
                </span>
              </div>
              <div class="game_status">
                <!--  -->
                <img v-if="item.matchInfo.state ==1 || item.matchInfo.state ==3 || item.matchInfo.state ==4" src="https://oss.ansongqiubo.com/static/scope/time.png" alt="" srcset="">
                <span>{{item.matchInfo.ffscope}}</span>
                <img v-if="item.matchInfo.state > 0 && item.matchInfo.state !=2" style="width:5px;height:14px" src="https://oss.ansongqiubo.com/static/scope/in.gif" alt="" srcset="">
                <span style="width: 5px;height:1px;display: inline-block;" v-else> </span>
              </div>
              <div class="ganm_uname">
                <div class="minwidth u-flex u-flex-end" style="text-align: right;">
                    <span v-if="item.matchData.homeYellowNum > 0" class="awayYellowNum">
                      {{item.matchData.homeYellowNum}}
                    </span>
                    <span v-if="item.matchData.homeRedNum >0 " class="awayRedNum">
                     {{item.matchData.homeRedNum}}
                    </span>
                    <span>{{item.homeTeam.nameCn}}</span>
                </div> <img
                  style="margin-left: 6px;"
                  :src="item.homeTeam.customLogo?item.homeTeam.customLogo:'https://oss.ansongqiubo.com/static/scope/defaultqiu.png'" alt="" srcset="">
              </div>
              <div class="game_bifen" @mouseout="mouseoutScore"  @mouseenter="mousemoveScore(item,$event)" style="font-size: 20px;" v-if="item.matchInfo.state !=0">
                {{item.matchData.homeScore}} - {{item.matchData.awayScore}}
              </div>
              <div class="game_bifen" style="color: #333;" v-else>
                VS
              </div>
              <div class="ganm_uname">
                <img style="margin-right: 6px;"
                  :src="item.awayTeam.customLogo?item.awayTeam.customLogo:'https://oss.ansongqiubo.com/static/scope/defaultqiu.png'" alt="" srcset="">
                <div class="minwidth  u-flex u-flex-start" style="text-align: left;">
                   <span>{{item.awayTeam.nameCn}}</span>
                    <span v-if="item.matchData.awayRedNum >0 " class="awayRedNum">
                     {{item.matchData.awayRedNum}}
                    </span>
                    <span v-if="item.matchData.awayYellowNum > 0" class="awayYellowNum">
                      {{item.matchData.awayYellowNum}}
                    </span>
                </div>
              </div>
              <div class="game_bifen" style="color: #333;" v-if="item.matchInfo.state !=0">
                 {{item.matchData.homeHalfScore}} - {{item.matchData.awayHalfScore}}
              </div>
              <div class="game_bifen" style="color: #333;" v-else >
                  -
              </div>
              <!-- 角球 -->
              <div class="game_bifen" style="color: #333;">
                <span>
                  <img src="https://oss.ansongqiubo.com/static/scope/jiaoqiu.png" alt="" srcset="" style="width: 14px;height: 14px;">
                   {{item.matchData.homeCornerNum}}
                </span>
                 -
                <span>
                 {{item.matchData.awayCornerNum}}
                  <!-- <img src="https://oss.ansongqiubo.com/static/scope/jiaoqiu.png" alt="" srcset="" style="width: 14px;height: 14px;"> -->
                </span>
              </div>
              <div class="play_game">
                <img v-if="item.anchor" @click.stop="openVideo(1,item)"  src="https://oss.ansongqiubo.com/static/scope/live.png" alt="" srcset="">
                <img v-if="item.matchLiveVO.haveAnimation == 1" @click.stop="openVideo(2,item)" src="https://oss.ansongqiubo.com/static/scope/animal.png" alt="" srcset="">
                <!-- <img   v-else src="https://oss.ansongqiubo.com/static/scope/info.png" alt="" srcset=""> -->
                <!--  <i style="color: #999;"
                  class="el-icon-arrow-right"></i> -->
              </div>
              <!-- 盘口信息 -->
              <div v-if="checkStatus == 1 && !hotstatus">
                <el-popover
                  placement="top"
                  width="500"
                  popper-class='popperClass'
                  trigger="hover">
                  <div>
                    <div style="text-align: center;height: 34px;background: #F2F2F2; color:#721EDC;line-height:34px">{{item.homeTeam.nameCn}} VS {{item.awayTeam.nameCn}}</div>
                    <div class="u-flex-y">
                      <div style="padding-left: 40px;margin: 12px 0;" class="u-flex u-flex-around">
                        <span>亚</span>
                        <span>欧</span>
                        <span>大</span>
                      </div>
                      <div class="u-flex-y"   style="margin-bottom:8px;" v-if="item.asiaOddsVO">
                        <div class="hoverBuyData u-flex u-flex-around hover" style="margin-bottom:12px;">
                          <span style="width:40px;">初盘</span>
                          <div >{{item.asiaOddsVO.firstHomeOdds}}</div>
                          <div>{{item.asiaOddsVO.firstGoal}}</div>
                          <div>{{item.asiaOddsVO.firstAwayOdds}}</div>


                          <div>{{item.europeOdds.firstHomeOdds}}</div>
                          <div>{{item.europeOdds.firstFlatOdds}}</div>
                          <div>{{item.europeOdds.firstAwayOdds}}</div>


                          <div>{{item.bsOddsVO.firstUpOdds}}</div>
                          <div>{{item.bsOddsVO.firstGoal}}</div>
                          <div>{{item.bsOddsVO.firstDownOdds}}</div>


                        </div>
                      <div class="hoverBuyData u-flex u-flex-around "  style="margin-bottom:12px;">
                        <span style="width:40px;">即时</span>
                       <div>{{item.asiaOddsVO.realHomeOdds}}</div>
                       <div>{{item.asiaOddsVO.realGoal}}</div>
                       <div>{{item.asiaOddsVO.realAwayOdds}}</div>


                       <div>{{item.europeOdds.realHomeOdds}}</div>
                       <div>{{item.europeOdds.realFlatOdds}}</div>
                       <div>{{item.europeOdds.realAwayOdds}}</div>


                       <div>{{item.bsOddsVO.realUpOdds}}</div>
                       <div>{{item.bsOddsVO.realGoal}}</div>
                       <div>{{item.bsOddsVO.realDownOdds}}</div>

                      </div>
                       <div class="hoverBuyData u-flex u-flex-around "  style="margin-bottom:12px;">
                         <span style="width:40px;">走地</span>
                         <div>{{item.asiaOddsVO.timelyHomeOdds}}</div>
                         <div>{{item.asiaOddsVO.timelyGoal}}</div>
                         <div>{{item.asiaOddsVO.timelyAwayOdds}}</div>


                         <div>{{item.europeOdds.timelyHomeOdds}}</div>
                         <div>{{item.europeOdds.timelyFlatOdds}}</div>
                         <div>{{item.europeOdds.timelyAwayOdds}}</div>


                         <div>{{item.bsOddsVO.timelyUpOdds}}</div>
                         <div>{{item.bsOddsVO.timelyGoal}}</div>
                         <div>{{item.bsOddsVO.timelyDownOdds}}</div>

                       </div>
                      </div>
                    </div>
                  </div>
                  <div slot="reference"  class="GoalBox" v-if="item.asiaOddsVO">
                    <div class="u-flex-y GoalBox_item">
                      <!-- 亚盘 -->
                      <span>
                        {{
                          startGoal1(item.asiaOddsVO.type,item)
                        }}
                      </span>
                      <!-- 大小球 -->
                      <span  class="aup">
                        {{
                           startGoal2(item.asiaOddsVO.type,item)
                        }}
                      </span>
                    </div>
                    <div class="u-flex-y GoalBox_item">
                      <span>
                        {{
                         Goal1(item.asiaOddsVO.type,item)
                        }}
                      </span>
                      <span>
                        {{
                          Goal2(item.asiaOddsVO.type,item)
                        }}
                      </span>
                    </div>
                    <div class="u-flex-y GoalBox_item">
                      <span>
                        {{
                          endGoal1(item.asiaOddsVO.type,item)
                        }}
                      </span>
                      <span class="adown">
                        {{
                          endGoal2(item.asiaOddsVO.type,item)
                        }}
                      </span>
                    </div>
                  </div>
                </el-popover>
              </div>
              <!-- 赛果 -->
              <div v-if="checkStatus ==3" class="GoalBox">
                <!-- 欧赔 没有盘口-->
                  <div class="u-flex u-flex-center GoalBox_item" :style="{'color':matchState(item).color}">
                    {{matchState(item).name}}
                  </div>
                  <!-- 盘口 -->
                  <div class="u-flex u-flex-center GoalBox_item">
                    {{item.asiaOddsVO.firstGoal}}
                  </div>
                  <!-- 大小球 -->
                  <div class=" u-flex u-flex-center GoalBox_item" :style="{'color':matchBigState(item).color}">
                    {{matchBigState(item).name}}
                  </div>
              </div>
            <div class="ctrlInfo" @click="routescore(1,item)">
              分析
            </div>
            <div class="ctrlInfo" @click="routescore(2,item)">
              走势
            </div>
            </div>
          </div>

        </div>
      </div>
      <!-- 未开始的比赛 -->
      <div class="sectionBox u-flex-y u-flex-center" v-if="scoresList[1] && scoresList[1].length>0 ">

        <div class="u-flex u-flex-items-center" style="margin: 24px; 0">
          <img style="width: 20px;height: 20px;margin-right:6px" src="https://oss.ansongqiubo.com/static/scope/nobegin.png" alt="" srcset="">
          <div class="bisaiCurrent">
            未开始的比赛
          </div>
        </div>
        <div class="score_game" v-loading='scoresList[1].length ==0'>
         <div  class="gameBox"   v-for="(item,index) in scoresList[1]" :key="index">
           <!-- 加时赛数据 -->
           <div class="addTimeData" v-if="item.matchExtra.normalTime > 0 && item.matchExtra.normalScore !=''">
               {{addTimefif(item.matchExtra,item)}}
           </div>
           <!-- 基础数据 -->
           <div class="game_item"   @click="navChange(item)">
            <div class="geme_title"> <div :style="{'width': '6px','margin-right':'6px','height': '40px','background':item.league.color?item.league.color:'#fff'}">
            </div> {{item.league.nameCnShort}} </div>
            <div class="geme_time" v-if="item.matchInfo">
              <span>
                {{ffTime(item.matchInfo.matchStartTime)}}
              </span>
            </div>
            <div class="game_status">
              <img v-if="item.matchInfo.state ==1 || item.matchInfo.state ==3 || item.matchInfo.state ==4" src="https://oss.ansongqiubo.com/static/scope/time.png" alt=""
                srcset=""><span  style="color: #333;">{{ffscope(item.matchInfo.state,item.matchInfo)}}</span>
            </div>
            <div class="ganm_uname">
              <div class="minwidth" style="text-align: right;">

              <span v-if="item.matchData.homeYellowNum > 0" class="awayYellowNum">
                {{item.matchData.homeYellowNum}}
              </span>
              <span v-if="item.matchData.homeRedNum >0 " class="awayRedNum">
               {{item.matchData.homeRedNum}}
              </span>
              {{item.homeTeam.nameCn}}</div> <img
                style="margin-left: 6px;"
                :src="item.homeTeam.customLogo?item.homeTeam.customLogo:'https://oss.ansongqiubo.com/static/scope/defaultqiu.png'" alt="" srcset="">
            </div>
            <div class="game_bifen"  style="font-size: 20px;" v-if="item.matchInfo.state !=0">
              {{item.matchData.homeScore}} - {{item.matchData.awayScore}}
            </div>
            <div class="game_bifen" style="color: #333;" v-else>
              -
            </div>
            <div class="ganm_uname">
              <img style="margin-right: 6px;"
                :src="item.awayTeam.customLogo?item.awayTeam.customLogo:'https://oss.ansongqiubo.com/static/scope/defaultqiu.png'" alt="" srcset="">
              <div class="minwidth" style="text-align: left;">
                  {{item.awayTeam.nameCn}}
                  <span v-if="item.matchData.awayRedNum >0 " class="awayRedNum">
                   {{item.matchData.awayRedNum}}
                  </span>
                  <span v-if="item.matchData.awayYellowNum > 0" class="awayYellowNum">
                    {{item.matchData.awayYellowNum}}
                  </span>
              </div>
            </div>
            <div class="game_bifen" style="color: #333;" v-if="item.matchInfo.state !=0">
               {{item.matchData.homeHalfScore}} - {{item.matchData.awayHalfScore}}
            </div>
            <div class="game_bifen" style="color: #333;" v-else >
            </div>
            <!-- 角球 -->
            <div class="game_bifen" style="color: #333;">
              <span>
                <img src="https://oss.ansongqiubo.com/static/scope/jiaoqiu.png" alt="" srcset="" style="width: 14px;height: 14px;">
                 {{item.matchData.homeCornerNum}}
              </span>
               -
              <span>
               {{item.matchData.awayCornerNum}}
                <!-- <img src="https://oss.ansongqiubo.com/static/scope/jiaoqiu.png" alt="" srcset="" style="width: 14px;height: 14px;"> -->
              </span>
            </div>
            <div class="play_game">
              <img v-if="item.anchor"  @click.stop="openVideo(1,item)" src="https://oss.ansongqiubo.com/static/scope/live.png" alt="" srcset="">
              <img v-if="item.matchLiveVO.haveAnimation == 1"   @click.stop="openVideo(2,item)" src="https://oss.ansongqiubo.com/static/scope/animal.png" alt="" srcset="">
              <!--  <i style="color: #999;"
                class="el-icon-arrow-right"></i> -->
            </div>

            <!-- 盘口信息 -->
            <div v-if="checkStatus == 1 && !hotstatus">

              <el-popover
                placement="top"
                width="500"
                popper-class='popperClass'
                trigger="hover">
                <div>
                  <div style="text-align: center;height: 34px;background: #F2F2F2; color:#721EDC;line-height:34px">{{item.homeTeam.nameCn}} VS {{item.awayTeam.nameCn}}</div>
                  <div class="u-flex-y">
                    <div style="padding-left: 40px;margin: 12px 0;" class="u-flex u-flex-around">
                      <span>亚</span>
                      <span>欧</span>
                      <span>大</span>
                    </div>
                    <div class="u-flex-y"   style="margin-bottom:8px;" v-if="item.asiaOddsVO">
                      <div class="hoverBuyData u-flex u-flex-around hover" style="margin-bottom:12px;">
                        <span style="width:40px;">初盘</span>
                        <div >{{item.asiaOddsVO.firstHomeOdds}}</div>
                        <div>{{item.asiaOddsVO.firstGoal}}</div>
                        <div>{{item.asiaOddsVO.firstAwayOdds}}</div>


                        <div>{{item.europeOdds.firstHomeOdds}}</div>
                        <div>{{item.europeOdds.firstFlatOdds}}</div>
                        <div>{{item.europeOdds.firstAwayOdds}}</div>


                        <div>{{item.bsOddsVO.firstUpOdds}}</div>
                        <div>{{item.bsOddsVO.firstGoal}}</div>
                        <div>{{item.bsOddsVO.firstDownOdds}}</div>


                      </div>
                    <div class="hoverBuyData u-flex u-flex-around "  style="margin-bottom:12px;">
                      <span style="width:40px;">即时</span>
                     <div>{{item.asiaOddsVO.realHomeOdds}}</div>
                     <div>{{item.asiaOddsVO.realGoal}}</div>
                     <div>{{item.asiaOddsVO.realAwayOdds}}</div>


                     <div>{{item.europeOdds.realHomeOdds}}</div>
                     <div>{{item.europeOdds.realFlatOdds}}</div>
                     <div>{{item.europeOdds.realAwayOdds}}</div>


                     <div>{{item.bsOddsVO.realUpOdds}}</div>
                     <div>{{item.bsOddsVO.realGoal}}</div>
                     <div>{{item.bsOddsVO.realDownOdds}}</div>

                    </div>
                     <div class="hoverBuyData u-flex u-flex-around "  style="margin-bottom:12px;">
                       <span style="width:40px;">走地</span>
                       <div>{{item.asiaOddsVO.timelyHomeOdds}}</div>
                       <div>{{item.asiaOddsVO.timelyGoal}}</div>
                       <div>{{item.asiaOddsVO.timelyAwayOdds}}</div>


                       <div>{{item.europeOdds.timelyHomeOdds}}</div>
                       <div>{{item.europeOdds.timelyFlatOdds}}</div>
                       <div>{{item.europeOdds.timelyAwayOdds}}</div>


                       <div>{{item.bsOddsVO.timelyUpOdds}}</div>
                       <div>{{item.bsOddsVO.timelyGoal}}</div>
                       <div>{{item.bsOddsVO.timelyDownOdds}}</div>

                     </div>
                    </div>
                  </div>
                </div>
                <div slot="reference"  class="GoalBox"  v-if="item.asiaOddsVO">
                  <div class="u-flex-y GoalBox_item">
                    <!-- 亚盘 -->
                    <span>
                      {{
                        startGoal1(item.asiaOddsVO.type,item)
                      }}
                    </span>
                    <!-- 大小球 -->
                    <span  class="aup">
                      {{
                         startGoal2(item.asiaOddsVO.type,item)
                      }}
                    </span>
                  </div>
                  <div class="u-flex-y GoalBox_item">
                    <span>
                      {{
                       Goal1(item.asiaOddsVO.type,item)
                      }}
                    </span>
                    <span>
                      {{
                        Goal2(item.asiaOddsVO.type,item)
                      }}
                    </span>
                  </div>
                  <div class="u-flex-y GoalBox_item">
                    <span>
                      {{
                        endGoal1(item.asiaOddsVO.type,item)
                      }}
                    </span>
                    <span class="adown">
                      {{
                        endGoal2(item.asiaOddsVO.type,item)
                      }}
                    </span>
                  </div>
                </div>
              </el-popover>



            </div>
            <!-- 赛果 -->
            <div v-if="checkStatus ==3" class="GoalBox">
              <!-- 欧赔 没有盘口-->
                <div class="u-flex u-flex-center GoalBox_item" :style="{'color':matchState(item).color}">
                  {{matchState(item).name}}
                </div>
                <!-- 盘口 -->
                <div class="u-flex u-flex-center GoalBox_item">
                  {{item.asiaOddsVO.firstGoal}}
                </div>
                <!-- 大小球 -->
                <div class=" u-flex u-flex-center GoalBox_item" :style="{'color':matchBigState(item).color}">
                  {{matchBigState(item).name}}
                </div>
            </div>
         <div class="ctrlInfo" @click="routescore(1,item)">
           分析
         </div>
         <div class="ctrlInfo" @click="routescore(2,item)">
           走势
         </div>
          </div>
        </div>
        </div>

      </div>

    </div>


    <div class="dialogStatus" v-if="dialogStatue">
        <div class="messgaesName">
            您确定要关闭声音吗？
        </div>
        <div class="messageBtn">
          <span @click="dialogStatue = false">
            取消
          </span>
          <span class="activeSpan" @click="btnConfim">
            确定
          </span>
        </div>
    </div>

    <!-- 未开始的比赛2 -->
    <div class="sectionBox u-flex-y u-flex-center" v-if="checkStatus != 1 || scoresList[2] && scoresList[2].length>0">
    <!-- 正在进行比赛的标题 -->
    <div class="headerTitle u-flex u-flex u-flex-between" v-if="checkStatus== 2 || hotstatus" style="margin-bottom:1px;border-bottom:1px solid rgba(0,0,0,.1)">
      <div class="checkitem" style="width: 100px;text-align:left">
        赛事
      </div>
      <div class="checkitem" style="min-width: 60px;;text-align: center;">
        时间
      </div>
      <div class="checkitem" style="text-align: center;width: 60px;;">
        状态
      </div>
      <div class="checkitem"  style="width: 194px;;text-align: right;">
        主场球队
      </div>
      <div class="checkitem" style="width: 74px;;text-align: center;">
        比分
      </div>
      <div class="checkitem"  style="width: 194px;;text-align: left;">
        客场球队
      </div>
      <div class="checkitem" style="text-align: center;width: 74px;">
        角球
      </div>
      <div class="checkitem" style="min-width:64px;text-align: center;">
        直播
      </div>
      <div class="checkitem" style="flex: 0.3;text-align: center;"  v-if="checkStatus == 3">
      </div>

      <div class="checkitem"  style="flex: 0.6;text-align: center;" v-if="checkStatus == 3">
        胜负
      </div>

      <div class="checkitem"  style="text-align: center;flex: 0.6;" v-if="checkStatus == 3">
        让球
      </div>
      <div class="checkitem" style="flex: 0.8;text-align: center;" v-if="checkStatus == 3">
        进球数
      </div>
      <div class="checkitem" style="text-align:right;width: 80px;">
        数据中心
      </div>
    </div>
    <div class="headerTitle u-flex u-flex u-flex-between" v-if="checkStatus== 3" style="margin-bottom:1px;border-bottom:1px solid rgba(0,0,0,.1)">
      <div class="checkitem" style="width: 100px;text-align:left">
        赛事
      </div>
      <div class="checkitem" style="min-width: 60px;;text-align: center;">
        时间
      </div>
      <div class="checkitem" style="text-align: center;width: 60px;;">
        状态
      </div>
      <div class="checkitem"  style="width: 194px;;text-align: right;">
        主场球队
      </div>
      <div class="checkitem" style="width: 74px;;text-align: center;">
        比分
      </div>
      <div class="checkitem"  style="width: 194px;;text-align: left;">
        客场球队
      </div>
      <div class="checkitem" style="text-align: center;width: 74px;">
        半场
      </div>
      <div class="checkitem" style="text-align: center;width: 74px;">
        角球
      </div>
      <div class="checkitem" style="min-width:64px;text-align: center;">
        直播
      </div>
      <div class="checkitem"  style="width: 64px;text-align: center;" v-if="checkStatus == 3">
        胜负
      </div>
      <div class="checkitem"  style="text-align: center;width: 64px;" v-if="checkStatus == 3">
        让球
      </div>
      <div class="checkitem" style="width: 64px;text-align: center;" v-if="checkStatus == 3">
        进球数
      </div>
      <div class="checkitem" style="text-align:right;width: 80px;">
        数据中心
      </div>
    </div>
      <div class="u-flex u-flex-items-center" style="margin: 24px; 0" v-if="checkStatus == 1">
        <img style="width: 20px;height: 20px;margin-right:6px" src="https://oss.ansongqiubo.com/static/scope/time.png" alt="" srcset="">
        <div class="bisaiCurrent">
            {{ffTimenext(scoresList[2][0].matchInfo.matchStartTime,scoresList[2])}}
        </div>
      </div>
      <div class="score_game" style="min-height:72vh ;" v-loading="scoresList[2] && scoresList[2].length == 0">
       <div  class="gameBox"   v-for="(item,index) in scoresList[2]" :key="index">
         <!-- 加时赛数据 -->
         <div class="addTimeData" v-if="item.matchExtra && item.matchExtra.normalTime > 0 && item.matchExtra.normalScore !=''">
             {{addTimefif(item.matchExtra,item)}}
         </div>
         <!-- 基础数据 -->
         <div class="game_item"   @click="navChange(item)">
          <div class="geme_title"> <div :style="{'width': '6px','margin-right':'6px','height': '40px','background':item.league.color?item.league.color:'#fff'}">
          </div> {{item.league.nameCnShort}} </div>
          <div class="geme_time" v-if="item.matchInfo">
            <span >
              {{ffTime(item.matchInfo.matchStartTime)}}
            </span>
          </div>
          <div class="game_status">
            <img v-if="item.matchInfo.state ==1 || item.matchInfo.state ==3 || item.matchInfo.state ==4" src="https://oss.ansongqiubo.com/static/scope/time.png" alt=""
              srcset=""><span style="color: #333;">{{ffscope(item.matchInfo.state,item.matchInfo)}}</span>
          </div>
          <div class="ganm_uname ">
            <div class="minwidth u-flex u-flex-end" style="text-align: right;">
              <span v-if="item.matchData.homeYellowNum > 0" class="awayYellowNum">
                {{item.matchData.homeYellowNum}}
              </span>
              <span v-if="item.matchData.homeRedNum >0 " class="awayRedNum">
               {{item.matchData.homeRedNum}}
              </span>
              <div>{{item.homeTeam.nameCn}}</div>
            </div>
             <img
              style="margin-left: 6px;"
              :src="item.homeTeam.customLogo?item.homeTeam.customLogo:'https://oss.ansongqiubo.com/static/scope/defaultqiu.png'" alt="" srcset="">
          </div>
          <div class="game_bifen"  @mouseout="mouseoutScore"  @mouseenter="mousemoveScore(item,$event)" style="font-size: 20px;" v-if="item.matchInfo.state !=0">
            {{item.matchData.homeScore}} - {{item.matchData.awayScore}}
          </div>
          <div class="game_bifen" style="color: #333;" v-else>
            -
          </div>
          <div class="ganm_uname">
            <img style="margin-right: 6px;"
              :src="item.awayTeam.customLogo?item.awayTeam.customLogo:'https://oss.ansongqiubo.com/static/scope/defaultqiu.png'" alt="" srcset="">
            <div class="minwidth  u-flex u-flex-start" style="text-align: left;">
              <div>{{item.awayTeam.nameCn}}</div>
                <span v-if="item.matchData.awayRedNum >0 " class="awayRedNum">
                                {{item.matchData.awayRedNum}}
                               </span>
                               <span v-if="item.matchData.awayYellowNum > 0" class="awayYellowNum">
                                 {{item.matchData.awayYellowNum}}
                               </span>
            </div>
          </div>
          <div class="game_bifen" style="color: #333;" v-if="item.matchInfo.state !=0 && checkStatus !=2">
             {{item.matchData.homeHalfScore}} - {{item.matchData.awayHalfScore}}
          </div>

          <!-- 角球 -->
          <div class="game_bifen" style="color: #333;">
            <img src="https://oss.ansongqiubo.com/static/scope/jiaoqiu.png" alt="" srcset="" style="width: 14px;height: 14px;">
            <span>
               {{item.matchData.homeCornerNum}}
            </span>
             -
            <span>
             {{item.matchData.awayCornerNum}}
              <!-- <img src="https://oss.ansongqiubo.com/static/scope/jiaoqiu.png" alt="" srcset="" style="width: 14px;height: 14px;"> -->
            </span>
          </div>
          <div class="play_game">
            <img v-if="item.anchor"  @click.stop="openVideo(1,item)" src="https://oss.ansongqiubo.com/static/scope/live.png" alt="" srcset="">
            <img v-if="item.matchLiveVO.haveAnimation == 1"  @click.stop="openVideo(2,item)" src="https://oss.ansongqiubo.com/static/scope/animal.png" alt="" srcset="">
            <!-- <img   v-else src="https://oss.ansongqiubo.com/static/scope/info.png" alt="" srcset=""> -->
            <!--  <i style="color: #999;"
              class="el-icon-arrow-right"></i> -->
          </div>

          <!-- 盘口信息 -->
          <div v-if="checkStatus == 1 && !hotstatus">

            <el-popover
              placement="top"
              width="500"
              popper-class='popperClass'
              trigger="hover">
              <div>
                <div style="text-align: center;height: 34px;background: #F2F2F2; color:#721EDC;line-height:34px">{{item.homeTeam.nameCn}} VS {{item.awayTeam.nameCn}}</div>
               <div class="u-flex-y">
                 <div style="padding-left: 40px;margin: 12px 0;" class="u-flex u-flex-around">
                   <span>亚</span>
                   <span>欧</span>
                   <span>大</span>
                 </div>
                 <div class="u-flex-y"   style="margin-bottom:8px;"  v-if="item.asiaOddsVO">
                   <div class="u-flex u-flex-around" style="margin-bottom:12px;">
                     <div style="width:40px;">初盘</div>
                     <div>{{item.asiaOddsVO.firstHomeOdds}}</div>
                     <div>{{item.asiaOddsVO.firstGoal}}</div>
                     <div>{{item.asiaOddsVO.firstAwayOdds}}</div>


                     <div>{{item.europeOdds.firstHomeOdds}}</div>
                     <div>{{item.europeOdds.firstFlatOdds}}</div>
                     <div>{{item.europeOdds.firstAwayOdds}}</div>


                     <div>{{item.bsOddsVO.firstUpOdds}}</div>
                     <div>{{item.bsOddsVO.firstGoal}}</div>
                     <div>{{item.bsOddsVO.firstDownOdds}}</div>


                   </div>
                 <div class="u-flex u-flex-around "  style="margin-bottom:12px;">
                   <div style="width:40px;">即时</div>
                  <div>{{item.asiaOddsVO.realHomeOdds}}</div>
                  <div>{{item.asiaOddsVO.realGoal}}</div>
                  <div>{{item.asiaOddsVO.realAwayOdds}}</div>


                  <div>{{item.europeOdds.realHomeOdds}}</div>
                  <div>{{item.europeOdds.realFlatOdds}}</div>
                  <div>{{item.europeOdds.realAwayOdds}}</div>


                  <div>{{item.bsOddsVO.realUpOdds}}</div>
                  <div>{{item.bsOddsVO.realGoal}}</div>
                  <div>{{item.bsOddsVO.realDownOdds}}</div>

                 </div>
                  <div class="u-flex u-flex-around "  style="margin-bottom:12px;">
                    <div style="width:40px;">走地</div>
                    <div>{{item.asiaOddsVO.timelyHomeOdds}}</div>
                    <div>{{item.asiaOddsVO.timelyGoal}}</div>
                    <div>{{item.asiaOddsVO.timelyAwayOdds}}</div>


                    <div>{{item.europeOdds.timelyHomeOdds}}</div>
                    <div>{{item.europeOdds.timelyFlatOdds}}</div>
                    <div>{{item.europeOdds.timelyAwayOdds}}</div>


                    <div>{{item.bsOddsVO.timelyUpOdds}}</div>
                    <div>{{item.bsOddsVO.timelyGoal}}</div>
                    <div>{{item.bsOddsVO.timelyDownOdds}}</div>

                  </div>
                 </div>
               </div>
              </div>
              <div slot="reference"  class="GoalBox"  v-if="item.asiaOddsVO">
                <div class="u-flex-y GoalBox_item">
                  <!-- 亚盘 -->
                  <span>
                    {{
                      startGoal1(item.asiaOddsVO.type,item)
                    }}
                  </span>
                  <!-- 大小球 -->
                  <span  class="aup">
                    {{
                       startGoal2(item.asiaOddsVO.type,item)
                    }}
                  </span>
                </div>
                <div class="u-flex-y GoalBox_item">
                  <span>
                    {{
                     Goal1(item.asiaOddsVO.type,item)
                    }}
                  </span>
                  <span>
                    {{
                      Goal2(item.asiaOddsVO.type,item)
                    }}
                  </span>
                </div>
                <div class="u-flex-y GoalBox_item">
                  <span>
                    {{
                      endGoal1(item.asiaOddsVO.type,item)
                    }}
                  </span>
                  <span class="adown">
                    {{
                      endGoal2(item.asiaOddsVO.type,item)
                    }}
                  </span>
                </div>
              </div>
            </el-popover>



          </div>
          <!-- 赛果 -->
          <div v-if="checkStatus ==3" class="GoalBox">
            <!-- 欧赔 没有盘口-->
              <div class="u-flex u-flex-center GoalBox_item" :style="{'color':matchState(item).color}">
                {{matchState(item).name}}
              </div>
              <!-- 盘口 -->
              <div class="u-flex u-flex-center GoalBox_item">
                {{item.asiaOddsVO.firstGoal}}
              </div>
              <!-- 大小球 -->
              <div class=" u-flex u-flex-center GoalBox_item" :style="{'color':matchBigState(item).color}">
                {{matchBigState(item).name}}
              </div>
          </div>
          <div style="width: 80px;display: flex;">
            <div class="ctrlInfo" @click="routescore(1,item)">
              分析
            </div>
            <div class="ctrlInfo" @click="routescore(2,item)">
              走势
          </div>

          </div>
        </div>
      </div>
      </div>
    </div>
    <dialogLive :userLive='userLive' ref="dialogLive"></dialogLive>
  </div>
</template>

<script>
  import Nav from "../component/Nav.vue";
  import audioData1 from '../../static/mp3/1.mp3'
  import audioData2 from '../../static/mp3/2.mp3'

  let GLOABL_TIME = null;
  let Moust_TIME =null;
  import {
    timelyList,resultsList,matchWillList,leagueFiltrate,matchInnerEvent,teamTechStatistic,matchListBeRelevanceAnchorList,resultsListV3,willListV3,timelyListV3,matchHotList
  } from '@/api/scope.js'
  import moment from 'moment'
  import momentDurationFormatSetup from 'moment-duration-format';
  import dialogLive from '@/pages/components/lz_dialogLives.vue';
  momentDurationFormatSetup(moment);
  import GlobalInfo from '@/lib/scoreSocket.js';
  import {Utf8ArrayToStr} from '@/lib/tools.js'
  import pako from 'pako';
  export default {
    components: {
      Nav,dialogLive
    },
    mounted(){
      this.audio1 = new Audio(audioData1);  // 创建音频对象

    },
    beforeDestroy() {
      clearInterval(GLOABL_TIME)
    },
    data() {
      return {
        uuid:new Date().getTime(),
        hotstatus:true,
        sumHiddenScopeIndex:0,
        dialogStatue:false,
        audio1: null,
        pageY:'',
        pageX:'',
        checkData:{
          days:1
        },
        routerIndex: '',
        checkStatus: 1,
        currentScoreHover:{},
        scoresList: [[],[],[]],
        selectAllData:[],
        initScoreList:[],
        serveInner:[],
        weekList:[],
        showScores:false,
        eventInner:{},
        userLive:[],
        speakstatus:false,  // 是否开启静音
        eventDialogInfo:[],
        messageDialogInfo:[],
        dialogCurrentInfo:false,
        showIndex:0,
        currentdialogInfo:{}
      }
    },
    created() {
      clearInterval(GLOABL_TIME)
      clearInterval(Moust_TIME)
      this.checkData.days =  moment().format("YYYYMMDD");
      this.initData();
      this.initGlobal()
      this.speakstatus = localStorage.getItem('speakstatus')==2?true:false;

       // console.log('声音', this.speakstatus,localStorage.getItem('speakstatus'));




    },
    methods: {
      btnConfim(){
        this.speakstatus = true;
        this.dialogStatue = false;
        localStorage.setItem('speakstatus',2);
      },
      changeSpeak(){
        if(this.speakstatus == false){
          this.dialogStatue = true;
        }else{
          this.speakstatus = false;
          localStorage.setItem('speakstatus',1);
        }
      },
      navChange(item){

        console.log('跳转',item)
        const neww = this.$router.resolve({
          path: "/pageAnalyse",
          query: {rid:3, tabId:3,matchId:item.matchInfo.matchId},
        });
        window.open(neww.href, "_self");
      },
      openVideo(e,val){
        console.log(val,e);
        if(e == 1){
          this.userLive = val.liveData.relevanceMatchAnchorVOList;
          this.$refs.dialogLive.open()
        }
        if(e ==2){
          // 动画
          const neww = this.$router.resolve({
            path: "/pageAnalyse",
            query: {rid:3, tabId:3,matchId:val.matchId},
          });
          window.open(neww.href, "_self");
        }
      },
      routescore(val,item){
        const neww = this.$router.resolve({
          path: "/pageAnalyse",
          query: {rid:3, tabId:val,matchId:item.matchId},
        });
        window.open(neww.href, "_self");
      },
      async initGlobal(){
        GlobalInfo.sucess = (e)=>{
          let Info = JSON.parse(e.data);
        console.log('比分页面监听。。。。',Info);

          switch (Info.messageType){
            case 10001:
              console.log('比赛比分相关数据推送',Info.message);
              // 在即时页面推
              if(this.checkStatus == 1){
                this.objectchange(Info.message)
              }
              break;
            case 10002:
              console.log('比赛相关事件',Info.message);
              this.EventChange(Info.message)
              break;
            // case 10003:
            //   console.log('比赛事件(删除错误的事件)',Info.message);
            //   // this.objectchange(Info.message)
            //   break;
            // case 10004:
            //   console.log('比赛角球事件',Info.message);
            //   // this.objectchange(Info.message)

            //   break;
            // case 10005:
            //   console.log(' 球队技术统计',Info.message);
            //   // this.objectchange(Info.message)
            //   break;

            default:
              break;
          }
        }
      },
     async  awaitMessage(){
        if(this.messageDialogInfo.length > 0){
            if(this.showIndex < this.messageDialogInfo.length){
              this.dialogCurrentInfo = true;

              this.currentdialogInfo = this.messageDialogInfo[this.showIndex];

              if(!this.speakstatus){
                if(this.currentdialogInfo.type == 1){
                   this.audio1.src =  audioData1  //音乐的路径
                  this.audio1.play()
                }
                if(this.currentdialogInfo.type == 2 || this.currentdialogInfo.type == 3){
                  this.audio1.src =  audioData2  //音乐的路径
                  this.audio1.play()
                }
              }





              this.showIndex ++;
              setTimeout(()=>{
                this.awaitMessage()
              },6000)
              setTimeout(()=>{
                this.dialogCurrentInfo = false;
              },5000)
            }else{
              if(this.eventDialogInfo.length > 0){
                this.messageDialogInfo  = this.eventDialogInfo.splice(0,this.eventDialogInfo.length);
                this.awaitMessage()
              }
                this.showIndex = 0;
            }
        }else{
          this.showIndex = 0;
          if(this.eventDialogInfo.length > 0){
            this.messageDialogInfo  = this.eventDialogInfo.splice(0,this.eventDialogInfo.length);
            this.awaitMessage()
          }
        }
      },
      // 事件推送
      EventChange(message,demo){
        if(demo == 1){
           message =  {matchEventVOList:[{
                   "content": "第3黄牌-阿尔瓦雷斯",// 事件内容
                    "eventId": 90481,
                    "happenTime": "68'",// 事件时间（分钟）
                    "kind": 2,// 球队类型，1:主队事件,2:客队事件
                    "sourceId": "9951390",
                    "type": 3 // 具体参看常量配置信息
          },
          {
                   "content": "第3黄牌-阿尔瓦雷斯",// 事件内容
                    "eventId": 90481,
                    "happenTime": "68'",// 事件时间（分钟）
                    "kind": 1,// 球队类型，1:主队事件,2:客队事件
                    "sourceId": "9951390",
                    "type": 1 // 具体参看常量配置信息
          }, {
                   "content": "第3黄牌-阿尔瓦雷斯",// 事件内容
                    "eventId": 90481,
                    "happenTime": "68'",// 事件时间（分钟）
                    "kind": 1,// 球队类型，1:主队事件,2:客队事件
                    "sourceId": "9951390",
                    "type": 2 // 具体参看常量配置信息
          }] ,
          matchId:'38799',
          relationMatchDataVO:{
                "awayCornerNum": 0, // 客队角球数
                 "awayId": 777, // 客队ID
                 "awayNameCn": "博雷斯拉夫", // 客队简体中文名称
                 "awayNameEn": "Mlada Boleslav", // 客队英文名称
                 "awayNameTrad": "波利斯拉夫", // 客队繁体中文名称
                 "awayRedNum": 0, // 客队红牌数
                 "awayScore": 2, // 客队比分
                 "awayYellowNum": 0, // 客队黄牌数
                 "homeCornerNum": 0, // 主队角球数
                 "homeId": 46607, // 主队ID
                 "homeNameCn": "梅索科菲德", // 主队简体中文名称
                 "homeNameEn": "Mezokovesd Zsory", // 主队英文名称
                 "homeNameTrad": "梅索科菲德",// 主队繁体中文名称
                 "homeRedNum": 0, // 主队红牌数
                 "homeScore": 1, // 主队比分
                 "homeYellowNum": 0, // 主队黄牌数
                 "matchId": 38799
          }}
        }



          let {matchEventVOList ,matchId,relationMatchDataVO} = message;
          let matchList = matchEventVOList.filter(item=>{
            if(item.type == 1 || item.type == 2 || item.type == 3){
              item.relationMatchDataVO = relationMatchDataVO;
              console.log('事件推送的数据详情',relationMatchDataVO);
              item.matchId = matchId
              return true;
            }else{
              return false
            }
        })
        this.eventDialogInfo = this.eventDialogInfo .concat(matchList);
        console.log('事件推送的数据', this.eventDialogInfo,matchList);
        if(this.showIndex == 0){
          this.awaitMessage()
        }
      },
      // 比分合并
      objectchange(data){
        let {matchInfoVO,matchExtraVO,matchDataVO}  = data;
        let changeArrIndex = 0,childArrIndex=0 ;
        let newArr = {};
        let newscoresList = JSON.parse(JSON.stringify(this.scoresList));
        console.log('数据不走了？',newscoresList);
        this.scoresList.map((item,index)=>{
          if(item.length > 0){
            item.map((val,indexs)=>{
              if(val.matchId == matchInfoVO.matchId){
                  changeArrIndex = index;
                  childArrIndex = indexs
                  newArr = val
              }
            })
          }
        })


        if(!newArr.matchData){
          console.log('没匹配到数据',newArr,changeArrIndex,childArrIndex);
          return
        }


        let {
           awayCornerNum, // 客队角球数
           awayHalfCornerNum, // 客队（半场）角球数
           awayHalfScore, // 客队（半场）比分
           awayRedNum, // 客队红牌数
           awayScore, // 客队比分
           homeCornerNum, // 主队角球数
           homeHalfCornerNum, // 主队(半场)角球数
           homeHalfScore, // 主队(半场)比分
           homeYellowNum, // 主队黄牌数
           awayYellowNum, // 客队黄牌数
           homeRedNum, // 主队红牌数
           homeScore // 主队比分
        } = matchDataVO;
         // this.$notify({
         //          title:`${newArr.homeTeam.nameCn} VS ${newArr.awayTeam.nameCn}`,
         //        });


        let {
            extraScore, // 加时: 加时阶段比分
            extraType,// 加时: 加时阶段类型，1:120分钟，2：加时，3：加时中
            firstKick,// 加时: 先开球方，1：主队先开球，2：客队先开球
            normalScore,// 加时: 常规时间的比分
            normalTime,// 加时: 常规时间
            penaltyKickScore,// 加时: 点球大战比分
            twoLegsScore,// 加时: 两回合总比分, 该字段仅在比赛有加时、点球的情况才更新
            win, // 加时: 获胜方，1：主队获胜，2：客队获胜
        } = matchExtraVO;
        let {
            awayId, // 客队ID
            firstHalfStartTime,// 上半场开始时间，单位：秒(有时候没有)
            homeId,// 主队ID
            matchId, // 比赛ID
            state, // 比赛状态
            matchStartTime, // 比赛时间，单位：秒
            secondHalfStartTime // 下半场开始时间，单位：秒
        } = matchInfoVO;

        //
        // if(newArr.length > 0){


          // 如果切换比比赛状态切换--基本信息






          // 如果加时赛数据



          // 比分相关数据


          let obj = {
            matchData:{  // 比赛相关数据
              awayCornerNum,  // 客队角球数(全场)
              awayHalfScore,  // 客队比分(半场)
              awayRedNum,     // 客队红牌数(全场)
              awayScore,      // 客队比分(全场)
              homeCornerNum,  // 主队角球数
              matchId,
              homeYellowNum,  // 主队黄牌数
              awayYellowNum,  // 客队黄牌数
              homeHalfScore,  // 主队(半场)比分
              homeRedNum,     // 主队红牌数
              homeScore,      // 主队比分
            },
            matchExtra:{
              extraScore,
              extraType,
              firstKick,
              normalScore,
              normalTime,
              penaltyKickScore,
              twoLegsScore,
              win,
            },
            matchInfo:{
              state,
              firstHalfStartTime,
              matchId,
              matchStartTime,
              secondHalfStartTime,
            },

          }


          newArr.matchData = obj.matchData;
          newArr.matchExtra = obj.matchExtra;
          newArr.matchInfo = obj.matchInfo;




          clearInterval(GLOABL_TIME)
          console.info('检查错误',changeArrIndex,childArrIndex,newArr,newscoresList);
          newscoresList[changeArrIndex][childArrIndex] = newArr;

          this.$set(this.scoresList[changeArrIndex], childArrIndex, newArr);
          this.updateData(this.scoresList.flat(1));
      },
      // 加时赛事务处理
      addTimefif(item,val){
        let str = '';
        if(item.normalScore  !=''){
          str += `90 分钟 【${item.normalScore}】`;
        }
        if(item.twoLegsScore != ''){
          str += `  两回合 【${item.twoLegsScore}】`;
        }
        if(item.extraScore != ''){
          str += ` 120分钟 【${item.extraScore}】`;
        }
        if(item.penaltyKickScore !=''){
          str += ` 点球 【${item.penaltyKickScore}】`
        }
        if(item.win !=''){
          let name  = item.win ==1?val.homeTeam.nameCn:val.awayTeam.nameCn
          str += ` ${name} 胜出`
        }
        return str
      },
      // 事件过滤任务
      eventfilter(val){
        // 0:角球
        // 1:入球
        // 2:红牌
        // 3:黄牌
        // 7:点球
        // 8:乌龙
        // 9:两黄变红
        // 11:换人
        // 13:射失点球
        // 14：视频裁判（VR裁判）

        // 30: 比赛开赛
        // 31: 比赛中场
        // 32: 上半场比分
        // 33: 下半场开始
        // 34: 比赛结束
        // 35: 全场最后得分
        let {type} =val;
          switch (type){
            case 0:
              return '角球'
            case 1:
              return '入球'
            case 2:
              return '红牌'
            case 3:
              return '黄牌'
            case 7:
              return '点球'
            case 8:
              return '乌龙'
            case 9:
              return'两黄变红'
            case 11:
              return'换人'
            case 13:
              return '射失点球'
            case 14:
              return '视频裁判'
            case 30:
              return '比赛开塞'
            case 31:
              return '比赛中场'
            case 32:
              return '上半场比分'
            case 33:
              return '下半场开始'
            case 34:
              return '比赛最后得分'
            case 35:
              return '全场最后得分'
            default:
              break;
        }
      },
      mouseoutScore(){
        if(Moust_TIME){
          clearTimeout(Moust_TIME)
        }
        Moust_TIME =  setTimeout(()=>{
          this.pageY = -13200
        },2200)
      },
      leaveScopre(){
        if(Moust_TIME){
          clearTimeout(Moust_TIME)
        }
        Moust_TIME =  setTimeout(()=>{
          this.pageY = -13200
        },2200)
      },
      enterScore(){
        clearTimeout(Moust_TIME)
      },
      // 鼠标 移动
      mousemoveScore(item,event){
        clearTimeout(Moust_TIME)
        console.log(item,event);

        // 记录当前的比赛
        this.currentScoreHover = item;
        // 如果有滚动条位置
        let {left,top,bottom,right,height,width} = event.target.getBoundingClientRect();
        this.pageY = event.target.offsetTop - event.target.clientHeight + 4;
        this.pageX = event.target.offsetLeft + event.target.clientWidth


        console.log('坐标',this.pageY,this.pageX);
        this.getinnerData(item.matchId)



      },
      getinnerData(matchId){
        teamTechStatistic({
          matchId
        }).then(res=>{
          console.log('技术统计',res);
           this.serveInner =res.data.data.map(item=>{
             item.homeValue = parseFloat(item.homeValue)
             item.awayValue = parseFloat(item.awayValue);
             return item
           })
        })
        matchInnerEvent({
          matchId
        }).then(res=>{
          this.eventInner =res.data.data;
          console.log('事件统计',res);
        })
      },
      ffTimenext(val){
        return moment.unix(val).format('YYYY年MM月DD日');
      },
      closeScore(){
        this.showScores = false
      },
      showSelect(){
        this.showScores = true;
      },
      checkAll(state){
        // 全选
        let copySelectBox = JSON.parse(JSON.stringify( this.selectAllData));
        if(state == 1){
          this.selectAllData = copySelectBox.map(item=>{
            if(item.filtrateList){
               item.filtrateList = item.filtrateList.map(items=>{
                  items.check = true
                  return items
               });
                 return item
            }
          });
        }
        // 反选
        if(state == 2){
          this.selectAllData = copySelectBox.map(item=>{
            if(item.filtrateList){
               item.filtrateList = item.filtrateList.map(items=>{
                  items.check = !items.check

                  return items
               });
                 return item
            }
          });

        }
        // 确认---过滤数据
        if(state == 3){

          let arr = [];
          let i = 0;
          copySelectBox.map(item=>{
            if(item.filtrateList){
               item.filtrateList.map(items=>{
                  if(items.check){
                      i++
                    arr.push(items.leagueId);
                  }
               });
            }
          });

          console.log('筛选id',arr);
          if(i<=0){
            this.$message.error('至少选择一种赛事');
            return
          }
          // 判断是即时还是赛果
          if(this.checkStatus == 1){
            clearInterval(GLOABL_TIME)
            this.scoresList =[[],[],[]]
            let newarr = this.initScoreList.map(item=>{
              item =  item.filter(items=>{
                let result = arr.some(vals =>vals == items.league.leagueId);
                  if(result){
                    console.log('可以的',result);
                      return true
                  }
               })
               return item
             })
              this.scoresList = newarr;
              this.timeAdd()
          }else{
            console.log('赛程赛果全部比赛', this.initScoreList[2])
            let fifDate = this.initScoreList[2].filter((item,index)=>{
              let result = arr.some(vals =>vals == item.league.leagueId);
                if(result){
                  console.log('可以的',result);
                    return true
                }else{
                  return false
                }
            })
            console.log('数据',fifDate);
            this.scoresList[2] = fifDate;
            this.$forceUpdate()
          }
        this.showScores = false;


        }
        setTimeout(()=>{
          this.sumHiddenScope()
        },1)
      },
      sumHiddenScope(){
        let indexs = 0
        this.selectAllData.map(item=>{
          item.filtrateList.map(items=>{
            if(!items.check){
              indexs+=items.matchCount
            }
          })
        })
        this.sumHiddenScopeIndex = indexs;
      },
      selectItem(items){
        items.check = !items.check;
        this.$forceUpdate();
        this.sumHiddenScope()
      },
      changeweekData(val){
        this.checkData.days = val.dateTime;
        this.initData()
        console.log('选择的日期',val.dateTime);
      },
      getWeek (date,currentday) { // 参数时间戳
            let week = moment(date).day()
            if(date == currentday){
              return '今天'
            }
            switch (week) {
              case 1:
                return '星期一'
              case 2:
                return '星期二'
              case 3:
                return '星期三'
              case 4:
                return '星期四'
              case 5:
                return '星期五'
              case 6:
                return '星期六'
              case 0:
                return '星期日'
            }
          },
      // 计时
      timeAdd(){
        if( this.scoresList[0] && this.scoresList[0].length > 0){
          let  arrs = this.scoresList[0];
           GLOABL_TIME = setInterval(()=>{
            arrs.forEach(item=>{
                if(item && item.matchInfo.state > 0){
                    item.matchInfo.ffscope = this.ffscope(item.matchInfo.state,item.matchInfo)
                }
            })
            this.scoresList[0] = arrs;
          },1000)
        }
      },
      // 进球数----------大小球
      matchBigState(item){
        let result = (item.matchData.homeScore  + item.matchData.awayScore) - item.bsOddsVO.firstGoal;
        if(result == 0){
          return {
            color:'#1076E9',
            name:'走'
          }
        }
        if(result > 0){
          return {
            color:'#ED1010',
            name:'大'
          }
        }else{
          return {
            color:'#58AF66',
            name:'小'
          }
        }
      },
      // 胜负
      matchState(item){
        // 比分计算
        if(item.matchData.homeScore  == item.matchData.awayScore){
          return {
            color:'#1076E9',
            name:'平'
          }
        }
        if(item.matchData.homeScore  > item.matchData.awayScore){
          return {
            color:'#ED1010',
            name:'胜'
          }
        }else{
          return {
            color:'#58AF66',
            name:'负'
          }
        }
      },
      // 亚盘
      startGoal1(type,item){
        switch (type){
          case 1: // 为空
            return ''
          case 2: // 初盘
            return item.asiaOddsVO.firstHomeOdds;
          case 3: // 即时
            return item.asiaOddsVO.realHomeOdds;
          case 4:  // 走低
            return item.asiaOddsVO.timelyHomeOdds;
          default:
            return ''
        }
      },
      // 大小球
      startGoal2(type,item){
        switch (type){
          case 1: // 为空
            return ''
          case 2: // 初盘
            return item.bsOddsVO.firstUpOdds;
          case 3: // 即时
            return item.bsOddsVO.realUpOdds;
          case 4:  // 走低
            return item.bsOddsVO.timelyUpOdds;
          default:
            return ''
        }
      },
      // 亚盘-盘口信息
      Goal1(type,item){
        switch (type){
          case 1: // 为空
            return ''
          case 2: // 初盘
            return item.asiaOddsVO.firstGoal;
          case 3: // 即时
            return item.asiaOddsVO.realGoal;
          case 4:  // 走低
            return item.asiaOddsVO.timelyGoal;
          default:
            return ''
        }
      },
      // 大小球-盘口信息
      Goal2(type,item){
        switch (type){
          case 1: // 为空
            return ''
          case 2: // 初盘
            return item.bsOddsVO.firstGoal;
          case 3: // 即时
            return item.bsOddsVO.realGoal;
          case 4:  // 走低
            return item.bsOddsVO.timelyGoal;
          default:
            return ''
        }
      },
      // 亚盘-客队
      endGoal1(type,item){
        switch (type){
          case 1: // 为空
            return ''
          case 2: // 初盘
            return item.asiaOddsVO.firstAwayOdds;
          case 3: // 即时
            return item.asiaOddsVO.realAwayOdds;
          case 4:  // 走低
            return item.asiaOddsVO.timelyAwayOdds;
          default:
            return ''
        }
      },
      // 大小球-小球
      endGoal2(type,item){
        switch (type){
          case 1: // 为空
            return ''
          case 2: // 初盘
            return item.bsOddsVO.firstDownOdds;
          case 3: // 即时
            return item.bsOddsVO.realDownOdds;
          case 4:  // 走低
            return item.bsOddsVO.timelyDownOdds;
          default:
            return ''
        }
      },
      ffTime(val) {
        return moment(val * 1000).format('HH:mm')
      },
      ffDate(val) {
        return moment(val * 1000).format('MM-DD')
      },
      // 时间状态
      ffscope(val, obj) {
        let keys = ''
        switch (val) {
          case -14:
            keys = '推迟'
            break;
          case -13:
            keys = '中断'
            break;
          case -12:
            keys = '腰斩'
            break;
          case -11:
            keys = '待定'
            break;
          case -10:
            keys = '取消'
            break;
          case -1:
            keys = '完'
            break;
          case 0:
            keys = '未'
            break;
          case 1:
            keys = '上半场'
            let begin = obj.firstHalfStartTime>0?obj.firstHalfStartTime:obj.matchStartTime;
            // 当前时间 - 比赛开始时间  = 正在进行的时间
            let date = moment.duration(begin, 'seconds').valueOf();
            let times = moment().diff(date, 'm')
            keys = times
            // console.log('上半场数据')
            if(keys > 45){
              keys  = '45+'
            }
            break;
          case 2:
            keys = '中'
            break;
          case 3:
            // console.log('下半场数据');
            if (obj.secondHalfStartTime > 0) {
              let dates = moment.unix(obj.secondHalfStartTime).valueOf(); // 下半场时间
              let valueTime = moment(new Date()).add(45, 'm').valueOf(); // 当前时间加上 45 分钟
              // 时间差
              let vdata = moment(valueTime).diff(dates, 'm');
              keys = vdata + 1;

              if(keys > 90){
                keys  = '90+'
              }
              // console.log(vdata)
            } else {
              let begin = obj.firstHalfStartTime>0?obj.firstHalfStartTime:obj.matchStartTime;
              let dates = moment.unix(begin).valueOf(); // 上半场时间
             let valueTime = moment().subtract(15, 'm').valueOf(); // 当前时间加上 45 分钟
             let vdata = moment(valueTime).diff(dates, 'm');

              keys = vdata;
              if(keys > 90){
                keys  = '90+'
              }
              // console.log(vdata)
            }
            break;
          case 4:
            keys = '加时'
            break;
          case 5:
            keys = '点球'
            break;
          default:
            break;
        }

        return keys
      },
      async initData() {

        clearInterval(GLOABL_TIME)
        let type = this.checkStatus ==1?1:this.checkStatus==2?3:2;
        this.selectAllData   = []
        // 获取筛选数据
        leagueFiltrate({
          filtrateType:1,
          queryType:type,
          dateTime:this.checkData.days,
        }).then(res=>{
          if(res.data.code == 200 && res.data.data) {
            let arr = res.data.data.map(item=>{
              if(item.filtrateList){
                 item.filtrateList = item.filtrateList.map(items=>{
                    items.check = false
                    return items
                 });
                   return item
              }
            });
            this.selectAllData  = JSON.parse(JSON.stringify(arr))
            this.checkAll(1)
            console.log('筛选数据',arr);
          }

        })



        // 获取比赛列表被关联的主播信息
        let matchaboutList = [];
        let aboutList = await matchListBeRelevanceAnchorList({
          matchType:1,
          queryType:type,
          dateTime:this.checkData.days,
        })
        if(aboutList.data.code == 200){
          console.log('我的数据',aboutList.data.data);
          matchaboutList = aboutList.data.data
        }
        this.scoresList = [[],[],[]];
        if(this.checkStatus == 1){
            if(this.hotstatus){
              let myhotList =  await matchHotList({
                matchType:1,
                limit:30
              })
              if(myhotList.data.code == 200){
                let arr = myhotList.data.data;
                let arrlist = [];
                arr.map(item=>{
                  arrlist.push(item.matchVO)
                })
                this.updateData(arrlist);
                console.log('热门比赛',this.scoresList);
              }
            }else{
              let DataList = await timelyListV3({
                 dateTime:this.checkData.days,
                 uuid:this.uuid,
              })
              if(DataList.data.code ==200){
                // console.log('赛果信息',res.data.data);
                let arrlist  = this.transitionData(DataList.data.data);
                 this.updateData(arrlist)
                 console.log('计时比赛', this.scoresList);
              }
            }
        }


        if(this.checkStatus == 2){
            let DataList = await willListV3({
               dateTime:this.checkData.days,
               uuid:this.uuid,
            })
            if(DataList.data.code ==200){
              // console.log('赛果信息',res.data.data);
              let arrlist  = this.transitionData(DataList.data.data);
               this.scoresList = [[],[],arrlist]
               console.log('赛程比赛', this.scoresList);
            }


          // let result = await matchWillList({
          //   'dateTime':this.checkData.days
          // });
          // if (result.data.code == 200) {
          //   let arrlist = result.data.data;
          //   this.scoresList = [[],[],arrlist]
          // }
          // console.log('赛程比赛', this.scoresList);
        }


        if(this.checkStatus == 3){
          console.log('测试v3版本');
          let DataList = await resultsListV3({
             dateTime:this.checkData.days,
             uuid:this.uuid,
          })
            if(DataList.data.code ==200){
             let arrlist  = this.transitionData(DataList.data.data);
             this.scoresList = [[],[],arrlist]
             console.log('赛果比赛', this.scoresList);
            }

          // let result = await resultsList({
          //   'dateTime':this.checkData.days
          // });
          // if (result.data.code == 200) {
          //   let arrlist = result.data.data;
          //   this.scoresList = [[],[],arrlist]
          // }
          // console.log('赛果比赛', this.scoresList);
        }

        // 判断有无主播关联
        this.scoresList.map(item =>{
          return item.map(items =>{
           let arrs =  matchaboutList.filter(val=>val.matchId == items.matchId)
            if(arrs.length > 0){
              items.anchor = true;
              items.liveData = arrs[0]
              console.log('有匹配到的',items);
            }
            return items
          })
        })


        console.log('最终数据',this.scoresList);
        // 保存一份原始数据；
        this.initScoreList = JSON.parse(JSON.stringify(this.scoresList));
      },
      transitionData(value){
        const strData = atob(value);
        // split it into an array rather than a "string"
        const charData = strData.split('').map(function(x){return x.charCodeAt(0); });
        // convert to binary
        const binData = new Uint8Array(charData);
        // inflate
        const result = pako.inflate(binData, { to: 'string' });
        return JSON.parse(result)
        console.log('数据转换',JSON.parse(result));
      },
      updateData(arrlist,type){
        // this.scoresList = result.data.data;
        arrlist = JSON.parse(JSON.stringify(arrlist));
        this.scoresList = [];
        let start = [],current = [],end = [];
        arrlist.map(item=>{
          if(item.matchInfo.state == 0){
           start.push(item)
          }else if(item.matchInfo.state > 0){
            let newobj = JSON.parse(JSON.stringify(item));
            newobj.matchInfo.ffscope = this.ffscope(item.matchInfo.state,item.matchInfo)
            current.push(newobj)
          }else{
            end.push(item);
            end.sort((a,b) =>{
             return b.matchInfo.matchStartTime - a.matchInfo.matchStartTime
            })


          }
        })
        console.log('比赛已结束的列表',end);
        this.scoresList = [current,start,end];
        this.timeAdd()
        this.$forceUpdate();
        if(type == 1){


           this.initScoreList = JSON.parse(JSON.stringify(this.scoresList));

        }
      },
      changesoft(e) {
        this.checkIndex = e;
        console.log((100 / 5) * (this.checkIndex + 1));
      },
      formatProgress(){
        return 0
      },
      switchItem(e,v) {
        let arrtime = [];
        let  date = moment().valueOf();
        let curday = date
        if(e==2){
          for(let i = 1;i<7;i++ ){
           arrtime.push({
              name:this.getWeek(date,curday),
              time: moment(date).format("MM/DD"),
              dateTime: moment(date).format("YYYYMMDD")
            })
            date = moment(moment(date).add(1, 'day')).valueOf()
          }
           this.weekList = arrtime
           this.checkData.days =  moment().format("YYYYMMDD");
          console.log('赛程',arrtime);
        }
        if(e==3){
          for(let i = 1;i<7;i++ ){
           arrtime.push({
              name:this.getWeek(date,curday),
              time: moment(date).format("MM/DD"),
              dateTime: moment(date).format("YYYYMMDD")
            })
            date = moment(moment(date).subtract(1, 'day')).valueOf()
          }
           this.weekList = arrtime.reverse();
           this.checkData.days =  moment().format("YYYYMMDD");
          console.log('赛果',arrtime);
        }
        if(v){
          this.hotstatus = true
        }else{
          this.hotstatus = false
        }
        this.checkStatus = e;
        this.initData();
      },
      // 切换路径
      changePage(e) {

        this.routerIndex = e;
        console.log("页面路径 :>> ", e);
      },
    }
  }
</script>
<style>
   .el-popover{
    padding: 0 !important;
  }
  </style>
<style lang="scss" scoped>
  @import '../assets/style/flex.scss';
    .dialogStatus{
      width: 286px;
      height: 152px;
      background: #FFFFFF;
      box-shadow: 0px 2px 10px 0px rgba(46,48,52,0.3000);
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      position: fixed;
      z-index: 999;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
      justify-content: space-between;
      align-items: center;
      padding:24px 38px;
      box-sizing: border-box;
      .messgaesName{
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }
      .activeSpan{
        background: #721EDC !important;
        color: #fff !important;
      }
      .messageBtn{
        display: flex;
        width: 100%;
        justify-content: space-between;
        span{
          cursor: pointer;
         width: 68px;
         line-height: 30px;
         text-align: center;
         height: 30px;
         border-radius: 100px;
         background: #DADADA;
         color: #666666;
        }
      }
    }
    .event_dialogShow{
      transform: translateX(-2999px);
      transition: all 0.1s;
      opacity: 0;
    }
    .event_dialogHide{
      transform: translateX(0);
      transition: all 0.1s;
      opacity: 1;
    }
    .event_dialog{
      width: 1200px;
      height: 82px;
      border-radius: 25px;
      position: fixed;
      left: calc(50vw - 300px);
      top: 200px;
      // border: 1px solid red;
      z-index: 99;
      .eventAway{
        display: flex;
        width: 600px;
        justify-content: flex-end;
        .myStateImg{
          margin-right: 11px !important;
          margin-left: 80px !important;
        }

        .homeName{
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #3C87FE !important;
        }
        .scopeNums{
          padding: 0 30px;
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          span:last-child{
            color: #3C87FE !important;
          }
        }
      }
      .eventstateImg{
        position:absolute;
        left: 0;
        z-index: -1;
        height: 82px;
        width: 600px;
        img{
          height: 82px;
          width: 600px;
        }
      }
      .pkscoreName{
        display: flex;
        align-items: center;
        padding:0 28px;
        height: 82px;
        .myStateImg{
          margin-right: 80px;
          margin-left: 11px;
        }
        .homeName{
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #721EDC;
        }
        .scopeNums{
          padding: 0 30px;
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          span:first-child{
            color: #721EDC;
          }
        }
        .awayName{
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          min-width:100px;
          color: #333333;
        }
        .event_time{
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #721EDC;
        }
      }
      .eventHome{
        display: flex;
      }
    }

    .hoverBuyData{
      span{
        text-align: center;
      }
      div{
        // border: 1px solid red;
        min-width: 40px;
        text-align: center;
        color: #999;
      }
      div:nth-child(3),div:nth-child(6),div:nth-child(9){
        color: #000;
      }

      div:nth-child(4),div:nth-child(7),div:nth-child(9){
        margin-right:10px;
      }
    }
  .pageScore {
    background: #F7F8FA;
    .firstListNo{
      min-height: calc(100vh - 132px);
    }
    .dialog_scope{
      position: absolute;
      z-index: 99;
      top:-9900px;
      transition: all .3s;
      width: 355px;
      background: rgba(0, 0, 0, .7);
      color: #fff;
      .myheight{
        max-height:  30vh;
        padding: 20px;
        box-sizing: border-box;
        overflow-y: scroll;
      }
      .eventSums{
        margin-top: 20px;
        border-top: 1px solid #333;
          box-sizing: border-box;
          flex: 1;
          .eventList{

          }
          .eventhander{
            margin-top: 12px;
            width: 98%;
            text-align: center;
            font-size: 16px;
            color: #fff;
          }
          .itemEvent{
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            font-size: 12px;
          }
          .progressData{
            width: 78px;
            height: 6px;
            border-radius: 4px;
          }
      }
      .dialogHeaders{
        width: 355px;
        height: 34px;
        font-size: 14px;
        box-sizing: border-box;
        padding:4px 10px;
        width: 100%;
        background: rgba(0, 0, 0, .8);
      }
      .dialog_box{
        overflow-y: scroll;
        background: rgba(0, 0, 0, .1);
      }
      .celData{
        width: 100%;
        margin:12px 16px;
        font-size: 12px;
        display: flex;
        align-items: center;
        .fristOne{
          flex: 1;
          line-height: 20px;
          font-size: 12px;
          img{
            margin:0 3px;
            vertical-align:middle;
          }
        }
        .centerOne{
          text-align: center;
          font-size: 12px;
          width:40px;
        }

      }
    }
  .awayRedNum{
    background-color: red;
    color: #fff;
	min-width: 14px;
    padding:0 2px;
    border-radius: 4px;
	text-align: center;
    margin: 0 2px;
    height: 20px;
  }
  .awayYellowNum{
    height: 20px;
    background-color: #FFC000;
    color: #fff;
	min-width: 14px;
    text-align: center;
    padding:0 2px;
    border-radius: 4px;
    margin: 0 2px;
  }
  }
  ::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 3px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 8px;
  }
  ::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    //background-color: #8c8c8c;
    background-color: #f1f1f1;
  }

  ::-webkit-scrollbar-track {
    background-color:rgba(0, 0, 0, .8);
  }

  ::-webkit-scrollbar-thumb,
  ::-webkit-scrollbar-track {
    border: 0;
  }

  /deep/ .el-popover{
    padding: 0 !important;
  }

  .popperClass{
    border: 1px solid red;
    padding: 0 !important;



  }
  .ctrlInfo{
    font-size: 14px;
    width: 40px;
    color: #333;
    text-align: center;
    cursor: pointer;
  }
  .ctrlInfo:hover{
    color: #721EDC;
  }

  .sectionBox {
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    .bisaiCurrent{
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
    .GoalBox{
      display: flex;
      .GoalBox_item{
        text-align: center;
        display: flex;
        width: 64px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        span:nth-child(1){
          color:#999;
        }

        .aup{
          color: #58AF66 !important;
        }
        .adown{
          color: #ED1010 !important;
        }
      }
    }
    .score_game {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      background: #FFFFFF;
      border-radius: 6px;

      .play_game {
        display: flex;
        align-items: center;
        min-width:64px ;

        justify-content: flex-end;
        img {
          width: 30px;
          height: 20px;
        }
        img:nth-child(2){
          margin-left: 8px;
        }
      }

      .game_bifen {
        width:74px;
        text-align:center;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ED1010;
      }
      .game_item:hover{
        background-color: rgba(114, 30, 220, .1);
        border-radius: 4px;
        cursor: pointer;
      }
      .gameBox:nth-child(2n){
        background: #F2F2F2 ;
      }
      .addTimeData{
        width: 1200px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 38px;
        background: #FFFFFF;
        box-shadow: 0px 0px 10px 0px rgba(114,30,220,0.3000);
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #721EDC;
      }
      .gameBox{
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-between;
        background: #FFFFFF;
      }

      .game_item {
        width: 100%;
        // border: 1px solid #DADADA;
        box-sizing: border-box;
        padding: 16px 12px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 67px;

        .ganm_uname {
          .minwidth {
            font-size: 14px;
            width: 168px;
            // display:inline-flex;
            // align-items: center;
          }

          font-size: 14px;
          font-family: PingFangSC-Regular,
          PingFang SC;
          font-weight: 400;
          color: #333333;
          display: flex;
          align-items: center;

          img {
            width: 20px;
            height: 20px;
          }
        }

        .geme_time {
          display: flex;
          flex-direction: column;
          align-items:center;
          min-width: 60px;


          span:nth-child(1) {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
          }
        }

        .geme_title {
          font-size: 14px;
          min-width: 100px;
          text-align: center;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          display: flex;
          align-items: center;
        }

        .game_status {
          font-size: 14px;
          width: 60px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #721EDC;
          display: flex;
          align-items: center;
          justify-content: center;

          img {
            margin-right: 4px;
            width: 14px;
            height: 14px;
          }
        }

        .softgameimg {
          width: 17px;
          height: 17px;
          // background: #000000;
          border-radius: 50%;

          img {
            border-radius: 50%;
            width: 17px;
            height: 17px;
            // background: #000000;
          }
        }
      }
    }

    .leftScore {
      width: 796px;
      height: 105px;
      background: #FFFFFF;
      padding: 0 10px;
      box-sizing: border-box;
      border-radius: 6px;

      .scoreStatus {
        font-size: 16px;
        height: 43px;
        line-height: 43px;
        text-align: left;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
      }

      .ar_title {
        height: 60px;
        line-height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid rgba(0, 0, 0, .1);

        span:nth-child(1) {
          border-bottom: 2px solid rebeccapurple;
          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #333333;
        }

        span:nth-child(2) {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
      }
    }
  }
  .myweekdata{
    max-width: 1200px;
    width: 100%;
    height: 60px;
    background: #F2F2F2;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 12px;
    .activedays{
      width: 100%;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      background: #FFFFFF;
      border-radius: 4px 0px 0px 4px;
      div{
        color: #721EDC !important;
      }
    }
    .weeks:hover div{
      color: #721EDC !important;
    }
    .weeks{
      text-align: center;
      user-select: none;
      cursor: pointer;
      flex: 1;
      div:nth-child(1){
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: #666666;
      }
      div:nth-child(2){
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #555;
      }
    }
  }
  .firstListNo{
    // min-height: 80vh;
    width: 1200px;
  }
  .firstList{
    min-height: 80vh;
    width: 1200px;
  }
  .headerTitle {
    min-width: 1200px;
    height: 40px;
    padding: 0 12px;
    background: #F2F2F2;
    border-radius: 4px;
    line-height: 40px;
    box-sizing: border-box;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    position: relative;
    .checkitem {
    }
  }

  .selectbox {
    max-width: 1200px;
    flex: 2;
    width: 100%;
    margin: 12px 0;

    .checkItem:hover .showselect{
      display: block;
    }
    .checkItem {
      cursor: pointer;
      margin-right: 12px;
      width: 80px;
      z-index: 99;
      height: 40px;
      background: #FFFFFF;
      border-radius: 4px;
      text-align: center;
      line-height: 40px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      position:relative;

        ::-webkit-scrollbar {
          /*滚动条整体样式*/
          width: 3px;
          /*高宽分别对应横竖滚动条的尺寸*/
          height: 8px;
        }
        ::-webkit-scrollbar-thumb {
          /*滚动条里面小方块*/
          border-radius: 10px;
          background-color: #8c8c8c;
        }

        ::-webkit-scrollbar-track {
          background-color:#fff;
        }

        ::-webkit-scrollbar-thumb,
        ::-webkit-scrollbar-track {
          border: 0;
        }


      .showselect{
         display: block;
         position: absolute;
         top:40px;
         left: 50%;
         transform: translateX(-50%);
         .beforeSanjiao{
           width: 100%;
           height: 18px;
           display: flex;
           align-items: center;
           justify-content: center;
           img{
             width: 24px;
             height: 18px;
             transform: translateY(4px);
           }
         }
      }

      .bottom-footer{
        position: absolute;
        display: flex;
        top: 356px;
        z-index:22;
        width: 400px;
        height: 54px;
        background: #FFFFFF;
        left: 50%;
        transform: translateX(-50%);
        box-shadow: 0px 2px 10px 0px rgba(46,48,52,0.3000);
        border-radius: 0px 0px 4px 4px;
        justify-content: flex-end;
        padding:10px 0;
        box-sizing: border-box;
        align-items: center;
        .allSelect{
          width: 60px;
          line-height: 32px;
          height: 32px;
          background: #FFFFFF;
          border-radius: 16px;
          border: 1px solid #979797;
          margin-right: 12px;
        }

        .allSelect:hover{
          color: #721EDC !important;
          border: 1px solid #721EDC;
        }

        .numsScope{
          display: flex;
          align-items: center;
          justify-content: flex-start;
          flex: 2;
          padding-left: 24px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
      }
      .alertselect{
        overflow-y: auto;
        width: 400px;
        height: 349px;
        background: #FFFFFF;
        box-shadow: 0px 2px 10px 0px rgba(46,48,52,0.3000);
        border-radius:4px;
        padding:18px 12px;
        box-sizing: border-box;

        .leftname{
          padding: 0 12px;
        }
        .itembox{
          flex: 2;
          display: flex;
          flex-flow: row wrap;
          border-bottom: 1px solid #F2F2F2;
          .itembox_check{
            display: flex;
            margin-right: 12px;
            align-items: center;
            .itemNames:hover{
              color: #721EDC !important;
            }
            .itemNames{
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

          }
        }
      }
    }

    .leftCheck {

      .active_check {
        background: #721EDC;
        color: #FFFFFF;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/pageScore.vue